// import {inject} from "vue";
import ApiRequest from "@/core/api-request";
import Alert from "@/components/layout/Alert";
import axios from "axios";
import Loading from "@/components/layout/Loading.js";
import $cookies from "vue-cookies"

const base_url = process.env.VUE_APP_LOGIN_BASE_URL;

export default {
    install: (app) => {
        app.config.globalProperties.$auth = {
            attempt,
            login,
            logout,
            user,
            token,
            check
        };
    }
};

function attempt(username, password) {
    return axios.post(base_url + '/api/auth/login', {
        login: username,
        password: password
    }).catch(function (error) {
        console.error("Lỗi", error);
        Loading.hide({element: 'body'});
        if (error.response.data) {
            Alert.error({message: error.response.data.message, title: "Đăng nhập thất bại"})
        } else {
            Alert.error({message: error.message, title: "Đăng nhập thất bại"})
        }
    }).then(function (result) {
        if (result) {
            Loading.hide({element: 'body'})
            console.log("ok", result);
            login(result.data.data.user, result.data.data.token)
        }
    });
}

function login(user, token) {
    localStorage.setItem('user', JSON.stringify(user));
    if (token) {
        $cookies.set('token', token);
    }
    window.location.reload();
}

function logout() {
    localStorage.removeItem('user');
    $cookies.remove('token');
    window.location.reload();
}

function user(from_serve = false) {
    if (from_serve) {
        if (!token()) return null;
        return ApiRequest.get({
            uri: '/api/auth/me',
        }).then((data) => {
            localStorage.setItem('user', JSON.stringify(data.user));
            return data.user
        }).catch((e) => {
                console.error(e);
            }
        )
    } else {
        try {
            return JSON.parse(localStorage.getItem('user'))
        } catch (e) {
            return null;
        }
    }

}

function check() {
    const _user = user(false);
    const _token = token();
    return (_user && _token);
}

function token() {
    return $cookies.get('token');
}




